<template>
    <a
        v-if="props.isLink"
        class="dropdown-item"
        :class="{'active' : props.active}"
        :href="props.href"
        @click="handleClick"
    >
        <slot />
    </a>
    <li
        v-else
        class="dropdown-item"
        :class="{'active' : props.active}"
        @click="handleClick"
        style="cursor:pointer;"
    >
        <slot />
    </li>
</template>

<script setup>

const props = defineProps({
    active: {
        type: Boolean,
        default: false
    },
    isLink: {
        type: Boolean,
        default: false
    },
    href: {
        type: String,
        default: null
    }
});

const handleClick = () => {
    // Handle the link click event
    // You can emit an event or perform other actions here
};

</script>

<style scoped>
</style>
